export default __webpack_public_path__ + "static/media/shared2youlogo.ed942024.jpg";